import { render, staticRenderFns } from "./MenuListItemGroup.vue?vue&type=template&id=07ebb62a&"
import script from "./MenuListItemGroup.vue?vue&type=script&lang=ts&"
export * from "./MenuListItemGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports